(function () {
  'use strict';
  if (typeof window.theme === 'undefined') return;
  if (window.theme.cartType !== 'drawer') return;

  function openDrawer() {
    var toggle   = document.querySelector('[data-action="toggle-mini-cart"]');
    var miniCart = document.getElementById('mini-cart');
    if (!toggle || !miniCart) return;
    if (toggle.getAttribute('aria-expanded') === 'true') return;
    toggle.setAttribute('aria-expanded', 'true');
    miniCart.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-mobile-scroll');
    var header = document.querySelector('.header');
    if (header) {
      miniCart.style.maxHeight = (window.innerHeight - header.getBoundingClientRect().bottom) + 'px';
    }
  }

  document.addEventListener('product:added', function () {
    openDrawer();
  }, true);

})();